<template>
  <v-dialog v-model="internalDialog" max-width="600px">
    <v-card>
      <v-card-title>
        <span class="headline">Edit Color</span>
      </v-card-title>
      <v-card-text>
        <v-container>
          <v-row>
            <v-col cols="12">
              <v-text-field
                color="orange"
                v-model="newLabel"
                label="Color's Label"
                outlined />
            </v-col>
            <v-col>
              <v-row justify="center">
                <v-color-picker v-model="newCode" elevation="5"></v-color-picker>
              </v-row>
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="orange" text @click="internalDialog = false" >
          Cancel
        </v-btn>
        <v-btn v-if="canDelete" color="orange" text @click="$emit('delete'); internalDialog = false">
          Delete
        </v-btn>
        <v-btn color="orange" text @click="onSubmit" >
          Submit
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'EditColorModal',
  props: ['dialog', 'code', 'label', 'canDelete'],

  data () {
    return {
      newCode: '',
      newLabel: ''
    }
  },

  watch: {
    code: {
      immediate: true,
      handler () {
        this.newCode = ((this.code.length === 7) && (this.code[0] === '#')) ? this.code : '#FFFFFF'
      }
    },
    label: {
      immediate: true,
      handler () {
        this.newLabel = this.label
      }
    }
  },

  computed: {
    internalDialog: {
      get () {
        return this.dialog
      },
      set (val) {
        this.$emit('close')
      }
    }
  },

  methods: {
    onSubmit () {
      this.$emit('update', {
        code: this.newCode,
        label: this.newLabel
      })
      this.internalDialog = false
    }
  }
}
</script>
